var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveChatSuccessfullyConnectedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 243.459,
    height: 191.034,
    viewBox: "0 0 243.459 191.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Successfully-Connected-live",
    transform: "translate(-672 -264.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_website_builder_re_ii6e",
    transform: "translate(672 264.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M946.123,648.348c-.967-7.774-5.785-15.434-13.2-17.964a36.1,36.1,0,0,1,0,24.781c-1.139,3.082-2.727,6.391-1.656,9.5A8.069,8.069,0,0,0,935.387,669a23.968,23.968,0,0,0,5.845,1.8l.393.325C944.8,663.957,947.089,656.123,946.123,648.348Z",
    transform: "translate(-712.752 -483.771)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M937.45,630.131a30.851,30.851,0,0,1,7.67,17.363,13.282,13.282,0,0,1-.151,4.16,7.619,7.619,0,0,1-1.9,3.534,15.765,15.765,0,0,0-2.448,2.929,4.665,4.665,0,0,0-.228,3.809,12.119,12.119,0,0,0,2.686,4.007,11.9,11.9,0,0,1,2.983,4.454c.062.214.39.1.328-.108-.889-3.067-3.866-4.809-5.286-7.571a4.725,4.725,0,0,1-.319-4.146,12.236,12.236,0,0,1,2.428-3.021,8.13,8.13,0,0,0,1.982-3.387,12.284,12.284,0,0,0,.311-4.139,29.93,29.93,0,0,0-2.186-9.1,31.4,31.4,0,0,0-5.646-9.048C937.531,629.706,937.3,629.966,937.45,630.131Z",
    transform: "translate(-717.352 -483.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M963.016,671.128a4.629,4.629,0,0,0,3.523-4.849.173.173,0,0,0-.345.017,4.286,4.286,0,0,1-3.287,4.5c-.216.051-.107.379.108.328Z",
    transform: "translate(-735.341 -509.094)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M948.059,702.663a8.922,8.922,0,0,1-3.984-5.138c-.063-.213-.391-.1-.328.108a9.28,9.28,0,0,0,4.156,5.338c.192.114.346-.2.155-.308Z",
    transform: "translate(-721.842 -531.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M945.36,650.423a2.621,2.621,0,0,1-2.483-.126c-.19-.116-.344.193-.155.308a2.936,2.936,0,0,0,2.746.146.178.178,0,0,0,.11-.218A.173.173,0,0,0,945.36,650.423Z",
    transform: "translate(-721.06 -497.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M860.264,676.025c.117.076.233.152.35.23a34.528,34.528,0,0,1,4.412,3.444c.108.1.216.2.321.294a36.375,36.375,0,0,1,7.9,10.814,35.327,35.327,0,0,1,1.935,5.006c.714,2.369,1.3,4.995,2.713,6.933a6.065,6.065,0,0,0,.472.583h12.772c.029-.015.058-.026.087-.041l.51.023c-.021-.09-.044-.184-.064-.274-.012-.052-.026-.1-.038-.157-.009-.035-.018-.07-.023-.1,0-.012-.006-.023-.009-.032-.006-.032-.015-.061-.021-.09q-.192-.782-.4-1.565s0,0,0-.006a51.941,51.941,0,0,0-4.371-11.476c-.058-.108-.117-.219-.181-.326a33.71,33.71,0,0,0-3.028-4.593,29.793,29.793,0,0,0-1.984-2.27,24.781,24.781,0,0,0-6.2-4.645,19.677,19.677,0,0,0-14.78-1.868C860.512,675.946,860.389,675.984,860.264,676.025Z",
    transform: "translate(-662.692 -515.526)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    d: "M860,677.745a30.851,30.851,0,0,1,16.578,9.246,13.287,13.287,0,0,1,2.384,3.412,7.621,7.621,0,0,1,.615,3.963,15.778,15.778,0,0,0-.191,3.813,4.666,4.666,0,0,0,2.111,3.178,12.125,12.125,0,0,0,4.557,1.582,11.9,11.9,0,0,1,5.064,1.76c.178.133.374-.151.2-.284-2.556-1.913-5.982-1.512-8.779-2.862a4.726,4.726,0,0,1-2.751-3.118,12.238,12.238,0,0,1,.12-3.875,8.131,8.131,0,0,0-.457-3.9,12.28,12.28,0,0,0-2.244-3.491,29.931,29.931,0,0,0-7.222-5.946,31.4,31.4,0,0,0-9.955-3.825c-.217-.043-.243.3-.027.344Z",
    transform: "translate(-662.397 -517.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M911.67,690.071a4.629,4.629,0,0,0-.106-5.993c-.147-.166-.412.055-.265.221a4.286,4.286,0,0,1,.087,5.575C911.245,690.045,911.529,690.241,911.67,690.071Z",
    transform: "translate(-698.824 -521.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    d: "M912.127,729.23a8.921,8.921,0,0,1-6.274-1.7c-.178-.133-.375.151-.2.284a9.28,9.28,0,0,0,6.533,1.76C912.41,729.545,912.347,729.206,912.127,729.23Z",
    transform: "translate(-694.807 -552.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M878.517,685.622a2.62,2.62,0,0,1-2.058,1.394c-.221.022-.158.361.062.34a2.936,2.936,0,0,0,2.281-1.537.178.178,0,0,0-.044-.24A.174.174,0,0,0,878.517,685.622Z",
    transform: "translate(-674.07 -522.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M413.151,155.235,260.72,127.308a2.342,2.342,0,0,0-.938.011,1.935,1.935,0,0,0-.77.36,1.811,1.811,0,0,0-.521.649,2.022,2.022,0,0,0-.191.877v136.56a2.022,2.022,0,0,0,.191.877,1.81,1.81,0,0,0,.52.649,1.935,1.935,0,0,0,.77.36,2.343,2.343,0,0,0,.938.012l152.432-27.928a.721.721,0,0,0,.339-.172,1.289,1.289,0,0,0,.276-.35,1.96,1.96,0,0,0,.186-.477,2.293,2.293,0,0,0,.068-.554v-81.39a2.294,2.294,0,0,0-.068-.555,1.963,1.963,0,0,0-.186-.477,1.292,1.292,0,0,0-.276-.35.723.723,0,0,0-.339-.172Z",
    transform: "translate(-236.145 -127.265)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2",
    "data-name": "Path 1",
    d: "M421.151,155.235,268.72,127.308a2.341,2.341,0,0,0-.938.011,1.935,1.935,0,0,0-.77.36,1.812,1.812,0,0,0-.521.649,2.022,2.022,0,0,0-.191.877v136.56a2.023,2.023,0,0,0,.191.877,1.81,1.81,0,0,0,.52.649,1.934,1.934,0,0,0,.77.36,2.342,2.342,0,0,0,.938.012l152.432-27.928a.721.721,0,0,0,.339-.172,1.289,1.289,0,0,0,.276-.35,1.961,1.961,0,0,0,.186-.477,2.292,2.292,0,0,0,.068-.554v-81.39a2.291,2.291,0,0,0-.068-.555,1.963,1.963,0,0,0-.186-.477,1.291,1.291,0,0,0-.276-.35.723.723,0,0,0-.339-.172Z",
    transform: "translate(-241.813 -127.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M421.151,155.235,268.72,127.308a2.341,2.341,0,0,0-.938.011,1.935,1.935,0,0,0-.77.36,1.812,1.812,0,0,0-.521.649,2.022,2.022,0,0,0-.191.877v136.56a2.023,2.023,0,0,0,.191.877,1.81,1.81,0,0,0,.52.649,1.934,1.934,0,0,0,.77.36,2.342,2.342,0,0,0,.938.012l152.432-27.928a.721.721,0,0,0,.339-.172,1.289,1.289,0,0,0,.276-.35,1.961,1.961,0,0,0,.186-.477,2.292,2.292,0,0,0,.068-.554v-81.39a2.291,2.291,0,0,0-.068-.555,1.963,1.963,0,0,0-.186-.477,1.291,1.291,0,0,0-.276-.35.723.723,0,0,0-.339-.172Zm.58,83a1.53,1.53,0,0,1-.046.371,1.309,1.309,0,0,1-.124.318.859.859,0,0,1-.184.233.481.481,0,0,1-.226.114l-152.43,27.618a1.56,1.56,0,0,1-.625-.009,1.291,1.291,0,0,1-.512-.24,1.208,1.208,0,0,1-.346-.432,1.348,1.348,0,0,1-.127-.583V129.349a1.349,1.349,0,0,1,.127-.583,1.208,1.208,0,0,1,.346-.433,1.289,1.289,0,0,1,.512-.241,1.559,1.559,0,0,1,.625-.009L421.151,155.7a.48.48,0,0,1,.226.114.859.859,0,0,1,.184.233,1.307,1.307,0,0,1,.124.318,1.527,1.527,0,0,1,.045.371v81.493Z",
    transform: "translate(-241.813 -127.265)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M182.271,258.827a6.372,6.372,0,0,1,.577-2.7,5.693,5.693,0,0,1,1.565-2.018,5.854,5.854,0,0,1,2.3-1.14,6.772,6.772,0,0,1,2.777-.084,8.018,8.018,0,0,1,2.736,1.016,8.817,8.817,0,0,1,2.2,1.861A8.635,8.635,0,0,1,195.9,258.2a7.6,7.6,0,0,1,.537,2.774,6.393,6.393,0,0,1-.537,2.611,5.709,5.709,0,0,1-1.472,1.995,5.81,5.81,0,0,1-2.2,1.192,6.662,6.662,0,0,1-2.736.186h0a7.922,7.922,0,0,1-2.775-.928,8.8,8.8,0,0,1-2.3-1.837,8.678,8.678,0,0,1-1.566-2.492A7.632,7.632,0,0,1,182.271,258.827Z",
    transform: "translate(-182.271 -216.203)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-2",
    "data-name": "Path 3",
    d: "M182.271,355.827a6.372,6.372,0,0,1,.577-2.7,5.693,5.693,0,0,1,1.565-2.018,5.854,5.854,0,0,1,2.3-1.14,6.771,6.771,0,0,1,2.777-.084,8.019,8.019,0,0,1,2.736,1.016,8.818,8.818,0,0,1,2.2,1.861A8.635,8.635,0,0,1,195.9,355.2a7.6,7.6,0,0,1,.537,2.774,6.393,6.393,0,0,1-.537,2.611,5.709,5.709,0,0,1-1.472,1.995,5.81,5.81,0,0,1-2.2,1.192,6.661,6.661,0,0,1-2.736.186h0a7.923,7.923,0,0,1-2.775-.928,8.8,8.8,0,0,1-2.3-1.837,8.677,8.677,0,0,1-1.566-2.492A7.632,7.632,0,0,1,182.271,355.827Z",
    transform: "translate(-182.271 -284.937)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-3",
    "data-name": "Path 3",
    d: "M182.271,452.827a6.372,6.372,0,0,1,.577-2.7,5.692,5.692,0,0,1,1.565-2.018,5.853,5.853,0,0,1,2.3-1.14,6.772,6.772,0,0,1,2.777-.084,8.018,8.018,0,0,1,2.736,1.016,8.817,8.817,0,0,1,2.2,1.861A8.636,8.636,0,0,1,195.9,452.2a7.6,7.6,0,0,1,.537,2.774,6.393,6.393,0,0,1-.537,2.611,5.709,5.709,0,0,1-1.472,1.995,5.81,5.81,0,0,1-2.2,1.192,6.663,6.663,0,0,1-2.736.186h0a7.923,7.923,0,0,1-2.775-.928,8.8,8.8,0,0,1-2.3-1.837,8.678,8.678,0,0,1-1.566-2.492A7.633,7.633,0,0,1,182.271,452.827Z",
    transform: "translate(-182.271 -353.67)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-4",
    "data-name": "Path 3",
    d: "M188.271,258.827a6.372,6.372,0,0,1,.577-2.7,5.693,5.693,0,0,1,1.565-2.018,5.854,5.854,0,0,1,2.3-1.14,6.772,6.772,0,0,1,2.777-.084,8.018,8.018,0,0,1,2.736,1.016,8.818,8.818,0,0,1,2.2,1.861A8.634,8.634,0,0,1,201.9,258.2a7.6,7.6,0,0,1,.537,2.774,6.393,6.393,0,0,1-.537,2.611,5.709,5.709,0,0,1-1.472,1.995,5.81,5.81,0,0,1-2.2,1.192,6.662,6.662,0,0,1-2.736.186h0a7.922,7.922,0,0,1-2.775-.928,8.8,8.8,0,0,1-2.3-1.837,8.679,8.679,0,0,1-1.566-2.492,7.632,7.632,0,0,1-.579-2.875Z",
    transform: "translate(-186.522 -216.203)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M188.271,354.037a6.663,6.663,0,0,1,.577-2.744,6.324,6.324,0,0,1,1.565-2.133,6.409,6.409,0,0,1,2.3-1.311,6.874,6.874,0,0,1,2.777-.289,7.507,7.507,0,0,1,2.736.813,7.92,7.92,0,0,1,2.2,1.7A7.828,7.828,0,0,1,201.9,352.4a7.294,7.294,0,0,1,.536,2.737,6.674,6.674,0,0,1-.537,2.652,6.343,6.343,0,0,1-3.676,3.459,6.818,6.818,0,0,1-2.736.388h0a7.464,7.464,0,0,1-2.775-.723,7.931,7.931,0,0,1-3.863-4.046A7.315,7.315,0,0,1,188.271,354.037Z",
    transform: "translate(-186.523 -283.339)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M188.271,449.162a6.968,6.968,0,0,1,2.143-5.036,7.115,7.115,0,0,1,11.486,2.4,7.025,7.025,0,0,1-6.411,9.705h0a7.129,7.129,0,0,1-6.638-4.276,7,7,0,0,1-.58-2.789Z",
    transform: "translate(-186.523 -350.39)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M201.652,267.7l2.116.325v-2.086a.628.628,0,0,1,.054-.262.556.556,0,0,1,.149-.2.569.569,0,0,1,.222-.114.66.66,0,0,1,.272-.012.79.79,0,0,1,.272.1.877.877,0,0,1,.222.184.862.862,0,0,1,.15.244.755.755,0,0,1,.056.278v2.084l2.076.319a.77.77,0,0,1,.268.1.859.859,0,0,1,.365.422.75.75,0,0,1,.054.276.63.63,0,0,1-.054.26.559.559,0,0,1-.146.2.566.566,0,0,1-.218.115.647.647,0,0,1-.268.014l-2.079-.311V271.7a.633.633,0,0,1-.055.262.569.569,0,0,1-.149.2.58.58,0,0,1-.221.117.662.662,0,0,1-.272.016.78.78,0,0,1-.272-.093.859.859,0,0,1-.222-.181.845.845,0,0,1-.15-.242.748.748,0,0,1-.054-.279v-2.086l-2.116-.318a.8.8,0,0,1-.276-.1.881.881,0,0,1-.226-.184.859.859,0,0,1-.152-.244.751.751,0,0,1-.056-.282.629.629,0,0,1,.056-.264.566.566,0,0,1,.152-.2.584.584,0,0,1,.226-.117A.677.677,0,0,1,201.652,267.7Z",
    transform: "translate(-195.501 -225.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M208.477,366.791l5.877.426h.022l-2.756-5a.22.22,0,0,0-.071-.078.215.215,0,0,0-.047-.024.2.2,0,0,0-.052-.011.191.191,0,0,0-.051,0,.18.18,0,0,0-.047.016.172.172,0,0,0-.071.066l-1.875,3.083-.09.148Z",
    transform: "translate(-200.841 -293.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M196.968,369.25l5.185.376-.994-1.508-.072-.109-1.3-1.978a.294.294,0,0,0-.135-.1.284.284,0,0,0-.056-.014.265.265,0,0,0-.056,0,.253.253,0,0,0-.053.009.24.24,0,0,0-.049.02.234.234,0,0,0-.044.031l0,.005-.006.005,0,.006,0,.006Z",
    transform: "translate(-192.685 -296.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    d: "M208.274,359.656a.938.938,0,0,1,.343.1,1,1,0,0,1,.279.211.982.982,0,0,1,.188.294.909.909,0,0,1,.069.346.824.824,0,0,1-.069.334.778.778,0,0,1-.188.262.788.788,0,0,1-.279.164.851.851,0,0,1-.343.041.938.938,0,0,1-.344-.1,1,1,0,0,1-.281-.211.983.983,0,0,1-.19-.294.91.91,0,0,1-.07-.347.824.824,0,0,1,.07-.335.778.778,0,0,1,.19-.262.79.79,0,0,1,.281-.163A.852.852,0,0,1,208.274,359.656Z",
    transform: "translate(-200.07 -291.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    d: "M428.034,293.861l58.188-55.209.249.437L428.4,294.328Z",
    transform: "translate(-356.417 -206.193)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    d: "M428.066,212.313l.365-.437,58.058,60.27-.25.415Z",
    transform: "translate(-356.44 -187.22)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M483.267,216.948,426.7,209.178a1.739,1.739,0,0,0-.78.066,1.676,1.676,0,0,0-.639.386,1.863,1.863,0,0,0-.433.641,2.214,2.214,0,0,0-.159.839V272a2.316,2.316,0,0,0,.159.851,2.083,2.083,0,0,0,.432.678,1.872,1.872,0,0,0,.639.437,1.793,1.793,0,0,0,.78.131l56.563-3.115a1.146,1.146,0,0,0,.538-.175,1.551,1.551,0,0,0,.437-.414,2.065,2.065,0,0,0,.294-.594,2.386,2.386,0,0,0,.108-.713V218.955a2.477,2.477,0,0,0-.108-.722,2.276,2.276,0,0,0-.294-.618,1.752,1.752,0,0,0-.437-.45A1.239,1.239,0,0,0,483.267,216.948ZM426.7,273.467a1.28,1.28,0,0,1-.556-.094,1.338,1.338,0,0,1-.456-.313,1.489,1.489,0,0,1-.308-.485,1.655,1.655,0,0,1-.114-.607V211.185a1.583,1.583,0,0,1,.114-.6,1.331,1.331,0,0,1,.308-.459,1.2,1.2,0,0,1,.456-.275,1.241,1.241,0,0,1,.556-.049l56.562,7.665a.884.884,0,0,1,.384.155,1.251,1.251,0,0,1,.313.321,1.625,1.625,0,0,1,.211.441,1.769,1.769,0,0,1,.078.516v50.2a1.708,1.708,0,0,1-.078.51,1.477,1.477,0,0,1-.211.424,1.107,1.107,0,0,1-.313.3.819.819,0,0,1-.384.123Z",
    transform: "translate(-354.05 -185.295)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b12ed9b2-cc32-4c4f-a9d5-2d1deb4d0e3e",
    transform: "translate(69.724 87.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M422.6,436.294a.863.863,0,0,0-.416.161,1.309,1.309,0,0,0-.337.365,1.871,1.871,0,0,0-.225.512,2.2,2.2,0,0,0-.078.607,2.044,2.044,0,0,0,.087.579,1.538,1.538,0,0,0,.227.46,1.024,1.024,0,0,0,.334.3.758.758,0,0,0,.408.092l99.021-8.2a.339.339,0,0,0,.209-.1.793.793,0,0,0,.172-.241,1.539,1.539,0,0,0,.117-.35,2.124,2.124,0,0,0,.045-.425,2.061,2.061,0,0,0-.038-.421,1.4,1.4,0,0,0-.112-.341.681.681,0,0,0-.167-.227.3.3,0,0,0-.208-.077h-.018Z",
    transform: "translate(-421.539 -428.992)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e10bb4bc-6df1-41b6-ac46-84090840b498",
    transform: "translate(69.724 94.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M422.6,461.685a.886.886,0,0,0-.416.173,1.364,1.364,0,0,0-.337.372,1.926,1.926,0,0,0-.225.518,2.218,2.218,0,0,0-.078.611,2.018,2.018,0,0,0,.087.577,1.489,1.489,0,0,0,.227.454.985.985,0,0,0,.334.289.745.745,0,0,0,.408.081l99.022-10.924a.35.35,0,0,0,.209-.1.824.824,0,0,0,.172-.246,1.575,1.575,0,0,0,.117-.354,2.147,2.147,0,0,0,.046-.426,2.04,2.04,0,0,0-.039-.42,1.37,1.37,0,0,0-.112-.337.657.657,0,0,0-.168-.221.3.3,0,0,0-.208-.071h-.017Z",
    transform: "translate(-421.539 -451.657)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e3c0a870-6a35-4470-a43f-0902a465f5fb",
    transform: "translate(69.724 101.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M422.6,486.668a.912.912,0,0,0-.416.184,1.42,1.42,0,0,0-.337.382,1.984,1.984,0,0,0-.225.525,2.244,2.244,0,0,0-.078.612,1.993,1.993,0,0,0,.087.574,1.438,1.438,0,0,0,.227.448.945.945,0,0,0,.334.28.735.735,0,0,0,.408.07l99.022-13.6a.361.361,0,0,0,.209-.107.857.857,0,0,0,.172-.251,1.62,1.62,0,0,0,.117-.358,2.159,2.159,0,0,0,.045-.427,2.028,2.028,0,0,0-.039-.419,1.332,1.332,0,0,0-.112-.335.631.631,0,0,0-.168-.217.291.291,0,0,0-.208-.066h-.018Z",
    transform: "translate(-421.54 -473.958)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M207.01,455.9l-5.653-.068a.8.8,0,0,0-.278.039.794.794,0,0,0-.24.127.781.781,0,0,0-.182.2.773.773,0,0,0-.1.257.752.752,0,0,0,.017.328.764.764,0,0,0,.061.154.776.776,0,0,0,.217.254.786.786,0,0,0,.468.159l1.7.015a.412.412,0,0,1,.376.25.4.4,0,0,1,.032.158v3.335a.776.776,0,0,0,.173.507.785.785,0,0,0,.46.277.762.762,0,0,0,.816-.429.752.752,0,0,0,.071-.317v-3.363a.4.4,0,0,1,.4-.4h0l1.624.013a.766.766,0,0,0,.776-.616.758.758,0,0,0-.738-.882Z",
    transform: "translate(-195.219 -360.085)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    d: "M220.911,471.484a.75.75,0,1,1-.691.458A.75.75,0,0,1,220.911,471.484Z",
    transform: "translate(-209.12 -371.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M658.53,309.219a3.893,3.893,0,0,1-.126.6l11.783,14.109,4.4-.758,2.013,6.492-7.66,2.1a2.965,2.965,0,0,1-3.31-1.307l-10.951-17.816a3.891,3.891,0,1,1,3.851-3.42Z",
    transform: "translate(-514.251 -253.105)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    d: "M718.57,361.992a1.666,1.666,0,0,1,1.156-.77l8.267-1.318a4.632,4.632,0,1,1,2.812,8.827l-7.553,3.672a1.668,1.668,0,0,1-2.32-1L718.4,363.37A1.666,1.666,0,0,1,718.57,361.992Z",
    transform: "translate(-562.112 -291.955)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    d: "M525.667,599.01h-3.573l-1.7-13.78h5.273Z",
    transform: "translate(-368.748 -414.689)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    d: "M695.873,760.41h-11.52v-.146a4.484,4.484,0,0,1,4.483-4.484h7.036Z",
    transform: "translate(-538.043 -572.626)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M653.667,599.01h-3.573l-1.7-13.78h5.273Z",
    transform: "translate(-459.448 -414.689)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M823.873,760.41h-11.52v-.146a4.484,4.484,0,0,1,4.483-4.484h7.036Z",
    transform: "translate(-628.743 -572.626)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M704.809,460.857l15.481-4.474c5.64,4,9.533,12.018,8.272,22.392-2.032,16.717,9.733,38.212,14.807,59.992l-8.774.276-19.212-45.978L704.12,540l-7.838.246,5.241-64.625Z",
    transform: "translate(-546.496 -360.475)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_228",
    "data-name": "Ellipse 228",
    cx: 8.008,
    cy: 8.008,
    r: 8.008,
    transform: "translate(157.199 43.709)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M716.618,371.626c-1.77-3.107-2.645-6.881-1.1-10.108a16.067,16.067,0,0,1,2-2.291L723.7,350l6.987-1.124c6.047,5.071.881,22.4,5.835,33.762l-20.69,11.073C717.312,388.065,719.308,376.348,716.618,371.626Z",
    transform: "translate(-559.559 -284.298)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M720.913,276.553s.542-1,3.788.291c1.136.454,1.669.349,1.743,1.336a18.831,18.831,0,0,0,3.9,10.209l.025.032L732,286.94l2.087,1.666,8.81.185s1.391-6.849-3.246-14.625S725.5,270.65,725.5,270.65C719.012,271.02,720.913,276.553,720.913,276.553Z",
    transform: "translate(-563.765 -228.042)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9-2",
    "data-name": "Path 9",
    d: "M508.958,239.669,452.4,231.9a1.739,1.739,0,0,0-.78.066,1.676,1.676,0,0,0-.639.386,1.863,1.863,0,0,0-.433.641,2.215,2.215,0,0,0-.159.839v60.887a2.315,2.315,0,0,0,.159.851,2.083,2.083,0,0,0,.432.678,1.872,1.872,0,0,0,.639.437,1.794,1.794,0,0,0,.779.131l56.563-3.115a1.147,1.147,0,0,0,.538-.175,1.553,1.553,0,0,0,.437-.414,2.067,2.067,0,0,0,.294-.594,2.386,2.386,0,0,0,.108-.713V241.676a2.477,2.477,0,0,0-.108-.722,2.276,2.276,0,0,0-.294-.618,1.754,1.754,0,0,0-.437-.45A1.238,1.238,0,0,0,508.958,239.669Z",
    transform: "translate(-372.255 -201.395)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9-3",
    "data-name": "Path 9",
    d: "M508.958,239.669,452.4,231.9a1.739,1.739,0,0,0-.78.066,1.676,1.676,0,0,0-.639.386,1.863,1.863,0,0,0-.433.641,2.215,2.215,0,0,0-.159.839v60.887a2.315,2.315,0,0,0,.159.851,2.083,2.083,0,0,0,.432.678,1.872,1.872,0,0,0,.639.437,1.794,1.794,0,0,0,.779.131l56.563-3.115a1.147,1.147,0,0,0,.538-.175,1.553,1.553,0,0,0,.437-.414,2.067,2.067,0,0,0,.294-.594,2.386,2.386,0,0,0,.108-.713V241.676a2.477,2.477,0,0,0-.108-.722,2.276,2.276,0,0,0-.294-.618,1.754,1.754,0,0,0-.437-.45A1.238,1.238,0,0,0,508.958,239.669Z",
    transform: "translate(-372.255 -201.395)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9-4",
    "data-name": "Path 9",
    d: "M516.958,239.669,460.4,231.9a1.739,1.739,0,0,0-.78.066,1.676,1.676,0,0,0-.639.386,1.863,1.863,0,0,0-.433.641,2.215,2.215,0,0,0-.159.839v60.887a2.315,2.315,0,0,0,.159.851,2.084,2.084,0,0,0,.432.678,1.872,1.872,0,0,0,.639.437,1.794,1.794,0,0,0,.779.131l56.563-3.115a1.147,1.147,0,0,0,.538-.175,1.553,1.553,0,0,0,.437-.414,2.067,2.067,0,0,0,.294-.594,2.388,2.388,0,0,0,.108-.713V241.676a2.477,2.477,0,0,0-.108-.722,2.276,2.276,0,0,0-.294-.618,1.754,1.754,0,0,0-.437-.45A1.238,1.238,0,0,0,516.958,239.669Z",
    transform: "translate(-377.923 -201.395)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M642.886,412.275a3.9,3.9,0,0,1,.428.441l18.287-1.869,1.835-4.072,6.506,1.966-2.547,7.523a2.965,2.965,0,0,1-2.936,2.012l-20.894-.9a3.891,3.891,0,1,1-.679-5.106Z",
    transform: "translate(-504.094 -325.324)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M721.18,387.829a1.666,1.666,0,0,1,.009-1.389l3.534-7.589a4.632,4.632,0,1,1,8.889,2.61l-1.184,8.315a1.668,1.668,0,0,1-2.126,1.364l-8.076-2.4a1.666,1.666,0,0,1-1.046-.914Z",
    transform: "translate(-564.033 -303.178)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M746.048,771.318H635.021a.291.291,0,0,1,0-.583H746.048a.291.291,0,0,1,0,.583Z",
    transform: "translate(-502.88 -583.223)",
    fill: "#cacaca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4394",
    "data-name": "Group 4394",
    transform: "translate(4231.021 11178.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    d: "M44.8,0A44.8,44.8,0,1,1,0,44.8,44.8,44.8,0,0,1,44.8,0Z",
    transform: "translate(-3463.021 -10811.693)",
    fill: "#009e50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M361.566,402.792a4.646,4.646,0,0,1-2.8-.929l-.05-.038-10.528-8.054a4.679,4.679,0,0,1,5.693-7.426l6.819,5.229,16.114-21.022a4.677,4.677,0,0,1,6.557-.866h0l-.1.139.1-.139a4.682,4.682,0,0,1,.865,6.558l-18.954,24.716a4.679,4.679,0,0,1-3.721,1.825Z",
    transform: "translate(-3784.229 -11152.6)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatSuccessfullyConnectedIcon);
export default __webpack_public_path__ + "static/media/live-chat-successfully-connected-icon.e0a0f38a025264d696bc0174b8240905.svg";
export { ForwardRef as ReactComponent };